import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

// Import location components (lazy-loaded for performance)
const LocationsList = React.lazy(() => import("./LocationsList"));
const NewLocation = React.lazy(() => import("./NewLocation"));
const LocationDetails = React.lazy(() => import("./LocationDetails"));

const locationsModuleConfig: ModuleConfig = {
    // Module Identity
    id: "locations",
    name: "Location Management",
    description: "Manage physical locations, buildings, rooms and areas for shifts and check-ins",
    version: "1.0.0",
    enabled: true,
    category: "operations",
    order: 4,
    icon: "📍",
    color: "#38A169",

    // Routes
    routes: [
        {
            path: "/locations",
            component: LocationsList,
            permissions: ["ADMIN"]
        },
        {
            path: "/locations/new",
            component: NewLocation,
            permissions: ["ADMIN"]
        },
        {
            path: "/locations/:id",
            component: LocationDetails,
            permissions: ["ADMIN"]
        },
        {
            path: "/locations/edit/:id",
            component: NewLocation, // Reuse NewLocation component for editing
            permissions: ["ADMIN"]
        }
    ],

    // Navigation
    navigation: [
        {
            label: "All Locations",
            path: "/locations",
            icon: "📍",
            permissions: ["ADMIN"]
        },
        {
            label: "Add Location",
            path: "/locations/new",
            icon: "➕",
            permissions: ["ADMIN"]
        }
    ],

    // Permissions
    permissions: {
        view: ["ADMIN"],
        create: ["ADMIN"],
        edit: ["ADMIN"],
        delete: ["ADMIN"]
    },

    // Quick Actions
    quickActions: [
        {
            label: "Add Location",
            path: "/locations/new",
            icon: "➕",
            description: "Register a new physical location"
        },
        {
            label: "View All",
            path: "/locations",
            icon: "📍",
            description: "View all locations"
        }
    ]
};

export default locationsModuleConfig;
